module.exports = __webpack_public_path__ + "static/media/elec.96cc65b0.svg";